<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ch-title">Contents</h1>
<h2 class="list2"><a href="#/xhtml/05_Chapter01"><span class="foot-sp">1 </span>Blood and Sand</a></h2>
<h2 class="list2"><a href="#/xhtml/06_Chapter02"><span class="foot-sp">2 </span>Murder of a Matador</a></h2>
<h2 class="list2"><span href="#/xhtml/07_Chapter03" title="Link target outside of Sample"><span class="foot-sp">3 </span>Magic Valley</span></h2>
<h2 class="list2"><span href="#/xhtml/08_Chapter04" title="Link target outside of Sample"><span class="foot-sp">4 </span>A Ring Round the Moon</span></h2>
<h2 class="list2"><span href="#/xhtml/09_Chapter05" title="Link target outside of Sample"><span class="foot-sp">5 </span>Lotus-Eater</span></h2>
<h2 class="list2"><span href="#/xhtml/10_Chapter06" title="Link target outside of Sample"><span class="foot-sp">6 </span>Dust of Mexico</span></h2>
<h2 class="list2"><span href="#/xhtml/11_Chapter07" title="Link target outside of Sample"><span class="foot-sp">7 </span>The Broken Man</span></h2>
<h2 class="list2"><span href="#/xhtml/12_Chapter08" title="Link target outside of Sample"><span class="foot-sp">8 </span>Sheriff</span></h2>
<h2 class="list2"><span href="#/xhtml/13_Chapter09" title="Link target outside of Sample"><span class="foot-sp">9 </span>Death on the Left</span></h2>
<h2 class="list3"><span href="#/xhtml/14_Chapter10" title="Link target outside of Sample"><span class="foot-sp1">10</span> The Triumph of the Emotions</span></h2>
<h2 class="list3"><span href="#/xhtml/15_Chapter11" title="Link target outside of Sample"><span class="foot-sp1">11</span> A Cloud Like a Man’s Hand</span></h2>
<h2 class="list3"><span href="#/xhtml/16_Chapter12" title="Link target outside of Sample"><span class="foot-sp1">12</span> International Bridge</span></h2>
<h2 class="list3"><span href="#/xhtml/17_Chapter13" title="Link target outside of Sample"><span class="foot-sp1">13</span> Bar Sinister</span></h2>
<h2 class="list3"><span href="#/xhtml/18_Chapter14" title="Link target outside of Sample"><span class="foot-sp1">14</span> The Mark of the Beast</span></h2>
<h2 class="list3"><span href="#/xhtml/19_Chapter15" title="Link target outside of Sample"><span class="foot-sp1">15</span> Tonatiuh</span></h2>
<h2 class="list3"><span href="#/xhtml/20_Chapter16" title="Link target outside of Sample"><span class="foot-sp1">16</span> Coup de Grâce</span></h2>
<h2 class="list3"><span href="#/xhtml/21_Chapter17" title="Link target outside of Sample"><span class="foot-sp1">17</span> The Shadowless Hour</span></h2>
<h2 class="list3"><span href="#/xhtml/22_Chapter18" title="Link target outside of Sample"><span class="foot-sp1">18</span> The Moment of Truth</span></h2>
<h2 class="list3"><span href="#/xhtml/23_Chapter19" title="Link target outside of Sample"><span class="foot-sp1">19</span> Sun on Capricorn</span></h2>
<h2 class="list3"><span href="#/xhtml/24_Chapter20" title="Link target outside of Sample"><span class="foot-sp1">20</span> The Criminal and His Motive</span><a id="page_6"></a></h2><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0b70379b